import { Modal } from 'bootstrap'
import CookieHelper from './CookieHelper'

/**
 * Manages the country popups visible state
 * Currently the popup is only displayed on .com for ja language and on ja for any other language than japanese
 */
export default class CountryPopup {
    constructor() {
        if (!this.hasUserDeactivatedPopup()) {
            this.countryPopupTemplate = document.querySelector('.js-country-popup-template')
            if (this.countryPopupTemplate) {
                const userLang = navigator.language || navigator.userLanguage
                const popupLanguage = this.countryPopupTemplate.dataset.countryPopupLanguage

                if ((popupLanguage !== 'ja' && userLang === 'ja') || (popupLanguage === 'ja' && userLang !== 'ja')) {
                    this.initializeCountryPopup()
                }
            }
        }
    }

    initializeCountryPopup() {
        const templateContent = this.countryPopupTemplate.content.cloneNode(true)
        document.body.append(templateContent)
        this.countryPopup = document.querySelector('.js-country-popup')
        this.countryPopupCloseButtons = document.querySelectorAll('.js-country-popup__close')
        this.countryPopupModal = new Modal(this.countryPopup, {})
        this.countryPopupModal.show()
        this.initializeCountryPopupCloseButton()
        this.initializeCountryPopupAcceptButton()
    }

    initializeCountryPopupAcceptButton() {
        if (window.location.hash) {
            let currentUrlAnchor = window.location.hash
            let acceptButton = document.querySelector('.js-country-popup__accept')
            let acceptButtonHref = acceptButton.href
            acceptButton.href = acceptButtonHref + currentUrlAnchor
        }
    }

    initializeCountryPopupCloseButton() {
        this.countryPopupCloseButtons.forEach((button) => {
            button.addEventListener('click', () => {
                this.countryPopupModal.hide()
                this.rememberCloseDecision()
            })
        })
    }

    rememberCloseDecision() {
        CookieHelper.setCookie('countryPopupClosed', 'true', 30)
        CookieHelper.setCookie('isLanguageSelectedByUser', 'true', 30)
    }

    hasUserDeactivatedPopup() {
        return CookieHelper.getCookie('countryPopupClosed') === 'true'
    }
}
